const videoAndTextBordered = Object.freeze([
  {
    blockId: 29,
    size: {
      w: 10,
      h: 6
    },
    position: {
      y: 1,
      x: 1
    },
    content_type: 'asset',
    asset_type: 'video',
    isTileCreator: true,
    blockSubtype: 'video',
    blockType: 'content',
    description: 'Add Video',
    alt_text: 'Standard video'
  },
  {
    blockId: 30,
    size: {
      w: 10,
      h: 6
    },
    position: {
      y: 1,
      x: 11
    },
    tile_caption: '<h2>Lorem ipsum dolor</h2><p>In condimentum mauris id leo varius, molestie luctus eros suscipit. Morbi a enim consectetur, fringilla ligula non</p><p><a class="secondary-button-style" href="#" target="_parent">Secondary</a></p>',
    content_type: 'text',
    blockType: 'content',
    blockSubtype: 'text',
    isTileCreator: false
  }
]);

export default videoAndTextBordered;